// Test / staging environment. Replace the host below with the actual test-server API URL.
// Build with: `npx ng build --configuration test`
// Or dev-serve against it with: `npx ng serve --configuration test`
export const environment = {
  production: true,
  apiUrl:             'https://demo.manarah.sa:7075/api',
  apiBaseUrl:         'https://demo.manarah.sa:7075',
  studioAuthBase:     'https://demo.manarah.sa:7075/api/v1/production-studio/auth',
  studioExternalBase: 'https://demo.manarah.sa:7075/api/v1/production-studio/external'
};
